<template>
  <transition name="slide-fade" appear>
    <div class="w-full">
      <div class="add-item-container flex w-full flex-col justify-between">
        <pack :item="item" v-if="item.type == 'seeds'" :packs="item.packs" v-on:item-selected="onItemSelected"></pack>
        <size v-else :sizes="item.sizes" v-on:item-selected="onItemSelected"></size>
        <div class="qty-price-container flex justify-between items-baseline mt-8">
          <div class="qty-container-left flex justify-center items-center gap-5">
            <div class="qty-container flex items-center">
              <input class="plus-minus" :class="quantity == 1 ? 'disabled' : ''" type="button" value="-" id="moins" @click="minus" />
              <input v-if="item.type == 'seeds'" class="input-qty" type="text" size="2" v-model="quantity" id="count" @keydown="checkIfNumeric($event)" disabled/>
              <input v-if="item.type == 'merch'" class="input-qty-merch" type="text" size="2" v-model="quantity" id="count" @keydown="checkIfNumeric($event)" disabled/>
              <input class="plus-minus" type="button" value="+" id="plus" @click="plus" />
            </div>
            <p v-if="item.type == 'merch'" class="price">
              {{ totalPriceCalculated | currency }}
              <span v-if="item.has_any_active_discount" class="line-through text-inactive-grey text-sm">{{ item.price * quantity | currency }}</span>
            </p>
          </div>
          <div>
            <btn-primary id="add-item" v-if="item.type == 'seeds'" :disabled="item.stock < 1  || !itemSelected" :handle-click="addItem" class="add-item-btn-seeds mb-3" :class="item.stock < 1 ? 'w-full' : ''" :text="item.stock < 1 ? trans.get('wizard.outOfStock') : trans.get('wizard.addToBag')" v-model="quantity"></btn-primary>
            <a class="flex items-start gap-2 underline hover:no-underline cursor-pointer ml-3 -mt-1" v-if="item.stock < 1" @click="showNotifyPopup=true">
              <svg width="20" height="25" viewBox="0 0 25 17" xmlns="http://www.w3.org/2000/svg" class="flex-none">
                  <path d="M25 .425a.4.4 0 0 0-.012-.06.4.4 0 0 0-.019-.09.416.416 0 0 0-.047-.08.4.4 0 0 0-.031-.053l-.01-.007a.442.442 0 0 0-.077-.057.388.388 0 0 0-.06-.04A1.664 1.664 0 0 0 24.57 0H.431a.436.436 0 0 0-.175.039.388.388 0 0 0-.06.04.422.422 0 0 0-.077.056l-.01.007a.381.381 0 0 0-.031.054.4.4 0 0 0-.047.078.399.399 0 0 0-.019.092A.383.383 0 0 0 0 .425V16.58c.003.039.01.078.024.115a.417.417 0 0 0 .01.047c.006.013.017.023.024.036a.44.44 0 0 0 .071.1l.003.004a.41.41 0 0 0 .062.04.408.408 0 0 0 .074.046A.436.436 0 0 0 .43 17h24.138a.436.436 0 0 0 .162-.032.4.4 0 0 0 .075-.047.393.393 0 0 0 .06-.039l.004-.004a.437.437 0 0 0 .071-.102.377.377 0 0 0 .024-.034.44.44 0 0 0 .01-.048.42.42 0 0 0 .025-.114V.425zm-24.138.95 7.4 6.513-7.4 7.628V1.374zM12.5 10.48 1.561.85H23.44L12.5 10.48zM8.905 8.455l3.308 2.912c.163.144.41.144.574 0l3.308-2.912 7.465 7.695H1.44l7.465-7.695zm7.833-.567 7.4-6.514v14.142l-7.4-7.628z" fill-rule="nonzero"/>
              </svg>
              {{ trans.get('product.stock_alert_message') }}
            </a>
          </div>
        </div>

        <FixedBar :item="item">
            <btn-primary id="add-item" v-if="item.type == 'seeds'" :disabled="item.stock < 1 || !itemSelected" :handle-click="addItem"
              class="w-full lg:max-w-sm h-14"
              :text="item.stock < 1 ? trans.get('wizard.outOfStock') : trans.get('wizard.addToBag') + ' / Pack ' + itemSelected.quantity + ' (x' + quantity + ')'"
              ></btn-primary>
              <btn-primary v-if="item.type == 'merch'" :disabled="item.stock < 1 || !itemSelected" :handle-click="addItem"
              class="w-full lg:max-w-sm h-14" :text="item.stock < 1 ? trans.get('wizard.outOfStock') : trans.get('wizard.addToBag')" v-model="quantity"></btn-primary>
        </FixedBar>
        <btn-primary v-if="item.type == 'merch'" :disabled="item.stock < 1 || !itemSelected" :handle-click="addItem" class="add-item-btn-merch mt-8" :text="item.stock < 1 ? trans.get('wizard.outOfStock') : trans.get('wizard.addToBag')" v-model="quantity"></btn-primary>
      </div>
      <div v-if="showNotifyPopup" class="modal-overlay px-5">
        <div class="modal relative">
          <div class="close-icon">
            <img src="/img/icons/close-black.svg" @click="showNotifyPopup = false"/>
          </div>
          <h4 class="mb-5">{{ trans.get('product.notify.title') }}</h4>
          <p class="mb-5 px-16">{{ trans.get('product.notify.description') }}</p>
          <input type="email" v-model="email" :placeholder="trans.get('product.notify.emailPlaceholder')" class="email-input">
          <a class="mt-4 inline-block btn btn-primary btn-more cursor-pointer" @click="notifyMe">{{ trans.get('product.notify.button') }}</a>
          <p class="my-5" v-html="trans.get('product.notify.privacy')"></p>
          <p v-if="message" class="success-msg">{{ message }}</p>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import BtnPrimary from '../../components/common/buttons/BtnPrimary';
import mixin from '../../mixin';
import { addCartItem } from '../../app/cart';
import Pack from './Pack';
import Size from './Size.vue';
import FixedBar from './FixedBar.vue';
import axios from 'axios';

export default {
  mixins: [mixin],
  components: {
    BtnPrimary,
    Pack,
    Size,
    FixedBar,
  },
  props: ['item'],
  data() {
    return {
      pack_quantity: null,
      quantity: 1,
      toastMessage: {
        es: 'Producto añadido al carrito correctamente',
        en: 'Product added to cart successfully',
      },
      loading: false,
      itemSelected: {},
      email:'',
      message:'',
      showNotifyPopup: false
    };
  },
  computed: {
    totalPriceCalculated() {
      if (this.item.type === 'merch' && this.item.discount) {
        return (this.item.price - (this.item.price * this.item.discount) / 100) * this.quantity;
      }
      return (this.item.type == 'merch' || !this.itemSelected.pivot ? this.item.price : this.itemSelected.pivot.price) * this.quantity;
    },
  },
  methods: {
    minus() {
      if (this.quantity > 1) this.quantity--;
    },
    plus() {
      if (this.quantity < this.item.stock) {
        this.quantity++;
      }
    },
    checkIfNumeric(e) {
      const k = e.keyCode;
      if (!([8, 9, 35, 36, 37, 39, 46].includes(k) || (k >= 48 && k <= 57) || (k >= 96 && k <= 105))) {
        e.preventDefault();
      }
    },
    onItemSelected(item) {
      this.itemSelected = item;
    },
    addItem() {
      const id = this.item.type == 'merch' ? `${this.item.id}x${this.itemSelected.name}` : `${this.item.id}x${this.itemSelected.quantity}`;
      const price = this.item.type == 'merch' ? this.item.final_price : this.itemSelected.pivot.final_price;
      const pack_quantity = this.item.type == 'merch' ? null : this.itemSelected.quantity;
      const size = this.item.type == 'merch' ? this.itemSelected.name : null;
      const description = this.item.type == 'merch' ? `${this.itemSelected.name}` : `Pack x${this.itemSelected.quantity}`;
      const original_price = this.item.type == 'merch' ? this.item.price : this.itemSelected.pivot.price;
      const promotion = this.item.promotions.length ? this.item.promotions[0].is_valid ? this.item.promotions[0] : null : null;
      addCartItem({
        id,
        quantity: Number(this.quantity),
        price,
        name: this.item.name,
        attributes: {
          image: this.item.images[0].webp || this.item.images[0].original,
          size,
          type: this.item.type,
          pack_quantity,
          description,
          original_price,
          product_id: this.item.id,
          product_url: this.item.url,
          promotion
        },
      },
      this.trans.get('wizard.toastMessage'),
    );
  },
  notifyMe() {
    if (!this.email || !this.validateEmail(this.email)) {
        this.message = this.trans.get('product.notify.error.invalidEmail');
        return;
    }

    const locale = this.trans.locale;
    console.log('locale',locale);

    axios.post('/api/notify-me', {
        email: this.email,
        product_id: this.item.id,
        locale: locale
    })
    .then(response => {
        this.message = this.trans.get('product.notify.success');
        setTimeout(() => {
            this.showNotifyPopup = false;
            this.message = '';
        }, 3000);
    })
    .catch(error => {
        if (error.response && error.response.status === 409) {
            this.message = this.trans.get('product.notify.error.alreadyRegistered');
        } else {
            this.message = this.trans.get('product.notify.error.general');
        }
    });
},

    validateEmail(email) {
      return /\S+@\S+\.\S+/.test(email);
    }
}
}
</script>

<style lang="scss" scoped>
@import "../../../sass/_variables.scss";

.add-item-container {
  @media (max-width: $breakpoint-landing-phone) {
    flex-direction: column;
  }

  .qty-price-container {
    gap: 35px;
    @media (max-width: $breakpoint-landing-phone) {
      flex-direction: column;
    }

    .qty-container-left {
      @media (max-width: $breakpoint-landing-phone) {
        flex-direction: column;
      }
    }

    .qty-container {
      input.plus-minus {
        font-size: 27px;
        background-color: transparent;
        cursor: pointer;
      }

      .disabled {
        opacity: 0.4;
      }

      input.input-qty, input.input-qty-merch {
        width: 52px;
        height: 40px;
        margin: 0 20px;
        text-align: center;
        border: 1px solid #adadad;
        background: transparent;
        border-radius: 23px;
        font-size: 18px;
        font-weight: bold;

        @media (min-width: $breakpoint-landing-phone) {
          width: 56px;
          height: 46px;

          &-merch {
            width: 56px;
            height: 40px;
            margin: 0 20px;
            text-align: center;
            border: 1px solid #000;
            background: transparent;
            font-size: 1.25rem;
            font-weight: bold;
          }

          @media (min-width: $breakpoint-landing-phone) {
            width: 56px;
            height: 46px;
          }
        }
      }
    }
  }

  .add-item-btn-seeds {
    height: 52px;

    @media (max-width: $breakpoint-landing-phone) {
      width: 100%;
      margin-top: 30px;
    }
  }

  .add-item-btn-merch {
    width: 100%;
    height: 56px;
  }

  .price {
    min-width: fit-content;
    @media (max-width: $breakpoint-landing-phone) {
      margin-top: 1rem;
    }
  }
}

.modal-overlay {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
}
.modal {
  background: white;
  padding: 50px;
  text-align: center;
  color: #000;
  z-index: 999;
}
.email-input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid $inactive-grey;
}
.success-msg {
  color: $corporative-green;
  margin-top: 10px;
  font-weight: bold;
}

</style>
